import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './country_flag.less'

class CopyBox extends React.Component {
  static propTypes = {
    country: PropTypes.string,
  }

  render() {
    return <div styleName={`country-flag ${this.props.country}`} />
  }
}

export default cssModules(CopyBox, styles, { allowMultiple: true })
